import React from "react";
import { useMyHrHeaderBadge } from "./use-header-badge";
import { OcAppBarBadge } from "oc/components";

export const MyHrHeaderBadge: React.FC = () => {
  const { handleClick, count } = useMyHrHeaderBadge();
  if (count === 0) return null;

  return (
    <OcAppBarBadge
      onClick={handleClick}
      icon="mdi:account-edit"
      id="my-hr-header-badge"
      badgeId="my-hr-header-badge-count"
      value={count}
    />
  );
};
